
import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { AuthService } from '../../../../shared/services/auth.service';

@Component({
  selector: 'app-manax-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
})
export class ChatComponent implements OnInit, AfterViewInit {
  @Input() show: boolean = false;
  menuCollapsed: boolean = false;
  profile: any = null;
  companyName!: string;
  companies: any = [];
  showChatPanel = false;
  messages: any[] = [];
  newMessage: any;
  constructor(
    private _AuthService: AuthService,
    // private _WebSocketService: WebSocketService,
    // private _ManaxitoService: ManaxitoService
  ) { }

  ngOnInit() {
    this.profile = this._AuthService.profile();
    this.companies = this.profile.company;
    // let socket = this._WebSocketService.getSocket();
    
    /*
    socket.on('new-gpt-message', (payload) => {
      this.messages.push({
        text: payload.message,
        sentBy: 'bot'
      })
    })
      */
    
  }

  ngAfterViewInit() {

  }

  sendMessage() {

    if (this.newMessage) {
      this.messages.push({
        text: this.newMessage,
        sentBy: 'user'
      })

      try {
        // this._ManaxitoService.sendMessage({ message: this.newMessage }).subscribe();
      } catch (e) {

      }
    }

    this.newMessage = "";

  }
}
